module.exports = __webpack_public_path__ + "static/media/banner-kz-form.c492f1b2.png";